import { Reveal } from "./Reveal";

const BENEFITS = [
  "Postavit sebevědomí na skutečných základech",
  "Vytvořit si vlastní směr",
  "Lépe rozumět ženám, přitažlivosti a seznamování",
  "Budovat zdravější vztahy",
  "Posílit disciplínu a převzít odpovědnost za svůj život",
  "Podívat se na sebe bez výmluv",
];

export const Benefits = () => (
  <section id="co-ziskas" className="grain relative bg-warmdark py-28 sm:py-36" data-testid="benefits-section">
    <div
      aria-hidden="true"
      className="pointer-events-none absolute inset-x-0 top-0 z-[2] h-48 bg-[radial-gradient(70%_100%_at_50%_0%,rgba(201,127,82,0.12),transparent_70%)]"
    />
    <div
      aria-hidden="true"
      className="pointer-events-none absolute inset-x-0 bottom-0 z-[2] h-48 bg-[radial-gradient(70%_100%_at_50%_100%,rgba(166,90,58,0.10),transparent_70%)]"
    />
    <div className="relative z-10 mx-auto max-w-7xl px-5 sm:px-8">
      <Reveal>
        <p className="mb-6 flex items-center gap-4 text-xs font-semibold uppercase tracking-[0.3em] text-copper">
          <span className="h-px w-10 bg-copper/60" aria-hidden="true" />
          Co ti kniha může dát
        </p>
      </Reveal>
      <div className="flex flex-col justify-between gap-8 lg:flex-row lg:items-end">
        <Reveal delay={0.1}>
          <h2 className="max-w-2xl font-serif text-4xl font-medium leading-[1.08] tracking-tight text-cream sm:text-5xl lg:text-6xl">
            Žádné zázraky.
            <br />
            <span className="italic text-copper">Pevnější základy.</span>
          </h2>
        </Reveal>
        <Reveal delay={0.2}>
          <p className="max-w-md text-base leading-relaxed text-cream/60 sm:text-lg">
            Kniha neslibuje, že získáš každou ženu, zbohatneš nebo se přes noc změníš. Nabízí
            lepší rámec pro přemýšlení — a principy, které jdou převést do života.
          </p>
        </Reveal>
      </div>

      <div className="mt-20 grid grid-cols-1 gap-px overflow-hidden rounded-lg border border-white/[0.07] bg-white/[0.07] sm:grid-cols-2 lg:grid-cols-3">
        {BENEFITS.map((b, i) => (
          <Reveal key={b} delay={0.06 * i} y={20}>
            <div className="group relative h-full bg-warmdark p-10 transition-colors duration-500 hover:bg-[#171310]">
              <span
                aria-hidden="true"
                className="pointer-events-none absolute right-6 top-4 font-serif text-8xl leading-none text-cream/[0.05] transition-colors duration-500 group-hover:text-copper/10"
              >
                {String(i + 1).padStart(2, "0")}
              </span>
              <span className="font-serif text-sm italic text-copper/80">
                {String(i + 1).padStart(2, "0")}
              </span>
              <p className="mt-24 font-serif text-2xl font-medium leading-snug text-cream">
                {b}
              </p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
